/* Controlled Chaos - product page extras (draft theme)
   1) colourway swatch linking to the sibling product
   2) delivery note inside "Product Details" for made-to-order pieces
   3) "Go one size up" note above the size buttons once a size is chosen
   (1) and (2) apply to the six pieces listed in snippets/cc-tweaks.liquid (cc_delivery) - that
   snippet renders #cc-delivery-tpl for those products only.
   (3) applies ONLY to the four tees listed in SIZE_UP_HANDLES below (not the joggers).
   The theme re-renders the product section when a variant changes, so every
   injected piece is re-added by a MutationObserver if the morph removes it. */
(function () {
  'use strict';

  var state = { sizeChosen: false };
  var SIZE_UP_TEXT = 'Go one size up';
  var SIZE_UP_HANDLES = [
    'abstract-graphic-tee',       /* The Chaotic Wolf Tee - Black */
    'the-chaotic-wolf-tee',       /* The Chaotic Wolf Tee - Off White */
    'edgewalkers-graphic-tees',   /* Edgewalkers' Collective Tee - Off White */
    'black-vintage-graphic-tee'   /* Edgewalkers' Collective Tee - Vintage Wash */
  ];

  function main() { return document.getElementById('MainContent'); }

  function currentHandle() {
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* true only on the four listed tees */
  function sizeUpEnabled() { return SIZE_UP_HANDLES.indexOf(currentHandle()) !== -1; }

  function ensureColorway() {
    var tpl = document.getElementById('cc-colorway-tpl');
    var m = main();
    if (!tpl || !m || m.querySelector('.cc-colorway')) return;
    var anchor = m.querySelector('.variant-picker');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor);
  }

  function ensureDelivery() {
    var tpl = document.getElementById('cc-delivery-tpl');
    var m = main();
    if (!tpl || !m || m.querySelector('.cc-delivery')) return;
    var sums = m.querySelectorAll('accordion-custom summary');
    for (var i = 0; i < sums.length; i++) {
      if (/product\s*details/i.test(sums[i].textContent || '')) {
        var box = sums[i].parentNode && sums[i].parentNode.querySelector('.details-content');
        if (box) { box.appendChild(tpl.content.cloneNode(true)); return; }
      }
    }
  }

  function isSizeLegend(legend) {
    return !!legend && /^\s*size/i.test(legend.textContent || '');
  }

  function ensureSizeNote() {
    if (!sizeUpEnabled() || !state.sizeChosen) return;
    var m = main();
    if (!m) return;
    var sets = m.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (!isSizeLegend(legend) || sets[i].querySelector('.cc-sizeup')) continue;
      var p = document.createElement('p');
      p.className = 'cc-sizeup';
      p.setAttribute('role', 'status');
      p.textContent = SIZE_UP_TEXT;
      legend.insertAdjacentElement('afterend', p);
    }
  }

  document.addEventListener('change', function (e) {
    if (!sizeUpEnabled()) return;
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest) return;
    var set = t.closest('fieldset.variant-option');
    if (!set || !isSizeLegend(set.querySelector('legend'))) return;
    state.sizeChosen = true;
    ensureSizeNote();
  }, true);

  var queued = 0;
  function run() {
    queued = 0;
    ensureColorway();
    ensureDelivery();
    ensureSizeNote();
  }
  function schedule() {
    if (!queued) queued = window.requestAnimationFrame(run);
  }

  function init() {
    run();
    var m = main();
    if (m && 'MutationObserver' in window) {
      new MutationObserver(schedule).observe(m, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();